/**
 * Pre-permit home check scheduling UI for CAP Read & Sign.
 */
import React from "react";
import { SiteSurveyAppointment } from "../../../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import {
  POST_CAP_EMPTY_SLOTS_MESSAGE,
  POST_CAP_HOME_CHECK_TEST_IDS,
} from "../../../checkout/components/molecules/siteSurveyScheduling";
import { CapAppointmentScheduler } from "./CapAppointmentScheduler";
import { type SiteSurveySlot } from "checkout/api/siteSurvey";

type PostCapHomeCheckSchedulerProps = {
  prospectTimeZoneId?: string;
  canSchedule?: boolean;
  bookingSnapshotLoading: boolean;
  scheduledAppointment: SiteSurveyAppointment | undefined;
  slotBookingParentId: string | undefined;
  slots: SiteSurveySlot[] | undefined;
  slotsLoading: boolean;
  slotsError: unknown;
  retrySlots: () => void;
  bookingLoading: boolean;
  rescheduleLoading: boolean;
  bookSlot: (slot: SiteSurveySlot) => Promise<unknown>;
  rescheduleAppointment: () => Promise<unknown>;
};

const PostCapHomeCheckScheduler: React.FC<PostCapHomeCheckSchedulerProps> = (
  props
) => (
  <CapAppointmentScheduler
    testIds={POST_CAP_HOME_CHECK_TEST_IDS}
    emptySlotsMessage={POST_CAP_EMPTY_SLOTS_MESSAGE}
    {...props}
  />
);

export type { PostCapHomeCheckSchedulerProps };
export { PostCapHomeCheckScheduler };
